import make, { Enum } from "@xaamin/enum";

export class EmisorStatusEnum extends Enum
{
  enum = {
    blocked:  -1,
    pending:  0,
    active:  1,
    invited:  2,
    external: 3,
    undefined: 99
  };

  isActive() {
    return this.getValue() === 1 || this.getValue() === 3;
  }
}

const EmisorStatus = make(EmisorStatusEnum);

export default EmisorStatus;